import React from "react";
import AddDeductTaxTableHead from "./AddDeductTaxTableHead";

/**
 * Table header for the Additions/Deductions table.
 * Reuses the shared AddDeductTaxTableHead component.
 */
const AddDedTableHead = React.memo(function AddDedTableHead(props) {
    return <AddDeductTaxTableHead title="Additions/Deduction" {...props} />;
});

export default AddDedTableHead;
